import { IconResourceType, ICON_TYPE, IconConfig} from "@spartacus/storefront";

export const genIconsConfig: IconConfig = {
  icon: {
    symbols: {
      TRASH: "icon-trash",
      STAR: "icon-star",
      INFO: "icon-info",
      HEADSET: "icon-headset",
      PIN: "icon-pin",
    },
    resources: [
      {
        type: IconResourceType.SVG,
        url: "./assets/icons/trash.svg",
        types: [ICON_TYPE.TRASH],
      },
      {
        type: IconResourceType.SVG,
        url: "./assets/icons/star.svg",
        types: [ICON_TYPE.STAR],
      },
      {
        type: IconResourceType.SVG,
        url: "./assets/icons/info.svg",
        types: [ICON_TYPE.INFO],
      },
      {
        type: IconResourceType.SVG,
        url: "./assets/icons/headset.svg",
        types: [ICON_TYPE.HEADSET],
      },
      {
        type: IconResourceType.SVG,
        url: "./assets/icons/pin.svg",
        types: [ICON_TYPE.PIN],
      }
    ],
  },
};